<template>
  <div>
    <div>
      <v-list>
        <v-list-item-group v-model="selectItem" color="primary">
          <v-list-item v-for="(item,index) in data" :key="index"
                       @click="open(item.subLevelModelList)">
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>
                arrow_forward_ios
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <!--    弹出-->
    <div v-if="drawer">
      <v-bottom-sheet
          v-model="drawer"
      >
        <v-sheet>
          <div class="virtual-scroll-class">

            <div class="virtual-scroll-item-class">
              <v-virtual-scroll
                  :bench="benched"
                  :items="subLevelModelList"
                  height="600px"
                  item-height="50"
              >

                <template v-slot:default="{item,index}">
                  <v-list>
                    <v-list-item-group v-model="leftItem" color="primary" @change="leftChange">
                      <v-list-item :key="index" :value="index">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                </template>

              </v-virtual-scroll>
            </div>

            <div class="virtual-scroll-item-class">
              <v-virtual-scroll
                  :bench="benched"
                  :items="rightItems"
                  height="600px"
                  item-height="50"
              >
                <template v-slot:default="{item,index}">

                  <v-list>
                    <v-list-item-group v-model="rightItem" color="primary">
                      <v-list-item :key="index" :value="index" @change="closeDrawer(item.code,item.name)">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                </template>
              </v-virtual-scroll>
            </div>

          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>

  </div>
</template>

<script>
export default {
  name: "position",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    leftItem: 0,
    rightItem: 0,
    benched: 0,
    drawer: false,
    subLevelModelList: [],
    selectItem: 0,
  }),
  computed: {
    rightItems() {
      return this.subLevelModelList[this.leftItem].subLevelModelList
    }
  },
  methods: {
    open(subLevelModelList) {
      this.leftItem = 0
      this.rightItem = 0
      this.subLevelModelList = subLevelModelList
      this.drawer = true
    },
    leftChange() {
      this.rightItem = 0
    },
    closeDrawer(code, name) {
      console.log(code, name)
      this.drawer = false
      this.$emit('change', code, name)
    }
  }
}
</script>

<style scoped>
.virtual-scroll-class {
  width: 100%;
}

.virtual-scroll-item-class {
  display: inline-block;
  width: 50%;
  padding: 10px;
}
</style>